module.exports = __webpack_public_path__ + "static/media/Fiora.021d3dbf.png";